import React, {useCallback, useMemo} from "react";
import {useNavigate, useLocation} from "react-router-dom";
import {LinkButton} from "./Button";
import ElementWithTooltip from "./ElementWithTooltip";
import config from "../config";
import {ReactComponent as ForekastsLogoSvg} from "../images/misc/Logo_Forekasts.svg";

import "../App.css";
import "./NavMenu.css";

function NavMenu(props) {
	const {userProvider} = props;

	const nav = useNavigate();
	const navigate = useCallback(
		(event) => {
			nav(event.currentTarget.value);
		},
		[nav],
	);

	const currentLocation = useLocation();
	const currentLocationUrl = currentLocation ? currentLocation.pathname : "";

	const federationConfig = useMemo(() => {
		return userProvider ? config.federationParameters[userProvider] : null;
	}, [userProvider]);

	const handleLeave = useCallback(() => {
		if (federationConfig?.homeUrl) {
			window.location.replace(federationConfig.homeUrl);
		}
	}, [federationConfig]);

	return (
		<div className="appNavMenu">
			<div>
				<div className="appLogo">
					<button onClick={navigate} value="/bienvenue">
						<img src={require("../images/misc/Logo BTPerf_2026_[quadri].png")} alt="Logo BTPerf" />
					</button>
				</div>

				<div className="userData">
					<div className="">
						<div className="centerAlign noWrapEllipsis bold">
							{((props.userFirstName || "").trim() + " " + (props.userLastName || "").trim()).trim()}
						</div>
						{/*<ElementWithTooltip tooltip="Quitter BTPerf"><LinkButton className="color-emphasis" onClick={handleLeave}><i className="bi bi-box-arrow-right"/></LinkButton></ElementWithTooltip>*/}
					</div>

					{/*<LinkButton onClick={handleSignin}>Cnx</LinkButton>*/}

					<div className="userCompany centerAlign marginTop05">
						{props.userCompanyData && props.userCompanyData.siren && (
							<>
								<ElementWithTooltip tooltip={props.userCompanyData.siren + " - " + props.userCompanyData.companyName}>
									<div className="noWrapEllipsis bold">{props.userCompanyData.companyName}</div>
								</ElementWithTooltip>
								{/*(props.userProfile === "multi-contextual" || props.userProfile === "no-context") && (
									<LinkButton onClick={navigate} value="/bienvenue">
										Changer d&apos;entreprise
									</LinkButton>
								)*/}
							</>
						)}
					</div>
				</div>

				<div className="appNavLinks">
					{props.userCompanyData &&
					props.userCompanyData.siren &&
					(props.userProfile === "multi-contextual" || props.userProfile === "no-context") ? (
						<button onClick={navigate} value="/bienvenue" disabled={currentLocationUrl === "/bienvenue"}>
							<i className="bi bi-buildings marginRight" />
							Changer d&apos;entreprise
						</button>
					) : (
						<div className="button-placeholder" />
					)}
					{[
						["/etats-financiers", "bi-file-ruled", "États financiers", false],
						["/analyses", "bi-graph-up", "Analyses", false],
						["/centre-aide", "bi-question-circle", "Centre d'aide", true],
					].map(([url, iconClassName, label, alwaysActive]) => (
						<button
							key={url}
							onClick={navigate}
							value={url}
							className={url === currentLocationUrl ? "active" : ""}
							disabled={!alwaysActive && (!props.userCompanyData || !props.userCompanyData.siren)}
						>
							<i className={"bi " + iconClassName + " marginRight"} />
							{label}
						</button>
					))}
					<button
						onClick={handleLeave}
						// className={url === currentLocationUrl ? "active" : ""}
					>
						<i className="bi bi-box-arrow-right marginRight" />
						Quitter BTPerf
					</button>
				</div>
			</div>

			<div className="navMenuFooter">
				<div className="flex alignItemsCenter justifySpaceAround">
					{federationConfig && (
					<>
						<a href={federationConfig.homeUrl} target="_blank" rel="noopener noreferrer">
							<img
								src={require("../images/misc/" + federationConfig.logo)}
								alt={federationConfig.logoAlt}
							/>
						</a>
						<a href="https://www.btp-banque.fr" target="_blank" rel="noopener noreferrer">
							<img src={require("../images/misc/logo-btp-banque-horizontal.png")} alt="Logo BTP Banque" />
						</a>
						{/*<a href="https://www.btp-banque.fr" target="_blank" rel="noopener noreferrer"><img src={require("../images/misc/logo-btp-banque-vertical.png")} alt="Logo BTP Banque"/></a>*/}
					</>
					)}
				</div>
				<div className="fkLogo flex alignItemsBaseline justifyCenter fontSize075 color-light-note semiBold marginTop10">
					<span className="marginRight10">Réalisé par</span>
					<ForekastsLogoSvg />
				</div>
				<div className="fontSize075 marginTop05">
					<LinkButton onClick={navigate} value="/conditions-generales-utilisation">
						Conditions Générales d&apos;Utilisation
					</LinkButton>
				</div>
			</div>
		</div>
	);
}

export default NavMenu;
